import { Pipe, PipeTransform } from '@angular/core';

/**
 * For request form answers stored as "value|label" (e.g. "1|ISS Live In Office"),
 * returns only the label part for display. Otherwise returns the value unchanged.
 */
@Pipe({ name: 'answerLabel' })
export class AnswerLabelPipe implements PipeTransform {
  transform(value: any): any {
    if (value == null) return value;
    if (typeof value !== 'string') return value;
    const s = value.trim();
    const i = s.indexOf('|');
    if (i >= 0) return s.substring(i + 1).trim() || s;
    return value;
  }
}
